let QuizManager = {

    init() {
        this.resultAddEvent();
        this.resultRemoveEvent();
        this.questionAddEvent();
        this.questionRemoveEvent();
        this.answerAddEvent();
        this.answerRemoveEvent();
        this.answerMinimizeEvent();
    },

    loadNewResult() {
        let context = $('#results');
        let panels = context.children('.panel');
        let last_index = panels.length ? panels.last().data('index') + 1 : 0;
        let quiz_id = panels.length ? panels.last().data('quiz-id') : 0;
        let type = this.getType();
        $.get(`/content/quiz/result_form/${quiz_id}/${type}/${last_index}`, function (data) {
            panels.length ? panels.last().after(data) : context.prepend(data);
            QuizManager.resultRemoveEvent();
            QuizManager.initImages();
        });
    },

    loadNewQuestion() {
        let context = $('#questions');
        let panels = context.children('.panel');
        let last_index = panels.length ? panels.last().data('index') + 1 : 0;
        let quiz_id = panels.length ? panels.last().data('quiz-id') : 0;
        let type = this.getType();
        $.get(`/content/quiz/question_form/${quiz_id}/${type}/${last_index}`, function (data) {
            panels.length ? panels.last().after(data) : context.prepend(data);
            QuizManager.answerAddEvent();
            QuizManager.questionRemoveEvent();
            QuizManager.initImages();
        });
    },

    loadNewAnswer(elem) {
        let context = $(elem).closest('.panel').find('.answers').first();
        let panels = context.children('.panel');
        let last_index = panels.length ? panels.last().data('index') + 1 : 0;
        let quiz_id = panels.length ? panels.last().data('quiz-id') : 0;
        let answer_index = $(elem).data('index');
        let type = this.getType();
        $.get(`/content/quiz/answer_form/${quiz_id}/${type}/${answer_index}/${last_index}`, function (data) {
            panels.length ? panels.last().after(data) : context.prepend(data);
            QuizManager.answerRemoveEvent();
            QuizManager.answerMinimizeEvent();
            QuizManager.initImages();
        });
    },

    resultAddEvent() {
        $("#add-new-result").off('click').on('click', function (evt) {
            evt.preventDefault();
            QuizManager.loadNewResult(evt.target);
        });
    },

    resultRemoveEvent() {
        $(".js-remove-quiz-result").off('click').on('click', function (evt) {
            evt.preventDefault();
            $(this).closest('.panel').remove();
        });
    },

    questionAddEvent() {
        $("#add-new-question").off('click').on('click', function (evt) {
            evt.preventDefault();
            QuizManager.loadNewQuestion(evt.target);
        });
    },

    questionRemoveEvent() {
        $(".js-remove-quiz-question").on('click', function (evt) {
            evt.preventDefault();
            $(this).closest('.panel').remove();
        });
    },

    answerAddEvent() {
        $(".add-new-answer").off('click').on('click', function (evt) {
            evt.preventDefault();
            QuizManager.loadNewAnswer(evt.target);
        });
    },

    answerRemoveEvent() {
        $(".remove-quiz-answer").off('click').on('click', function (evt) {
            evt.preventDefault();
            $(this).closest('.panel').remove();
        });
    },

    answerMinimizeEvent() {
        $(".minimize-quiz-answer").off('click').on('click', function (evt) {
            evt.preventDefault();
            $(this).closest('.panel').find('.panel-body').first().toggle();
        });
    },

    getType() {
        return $('input[name="type"]').val();
    },

    initImages() {
        import('./ImageInputAdminManager').then((ImageInputAdminManager) => {
            (new ImageInputAdminManager.default()).init();
        })
    },
};

export default QuizManager;
